import { render, staticRenderFns } from "./resume8.vue?vue&type=template&id=8b77e54c&scoped=true&"
import script from "./resume8.vue?vue&type=script&lang=js&"
export * from "./resume8.vue?vue&type=script&lang=js&"
import style0 from "./resume8.vue?vue&type=style&index=0&id=8b77e54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b77e54c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable,VTextField})
